import { getAmplitudeInstance } from '../amplitudeHelpers';

type logGarminRouteSentParams = {
  map_remote_id?: number;
  sent_by_user?: boolean;
  trail_id?: number;
};

/**
 * User successfully sends a route to Garmin.
 * @param params - Attributes to log with the amplitude event
 * @param params.map_remote_id - The ID associated with the route, which may not be linked to a trail.
 * @param params.sent_by_user - Boolean to indicate if a user sent the route (True) or if was auto-sent (False).
 * @param params.trail_id - The trail page the user was on when they tapped a link to complete an action.
 */
const logGarminRouteSent = ({ map_remote_id, sent_by_user, trail_id }: logGarminRouteSentParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'garmin route sent',
    { 'map remote id': map_remote_id, 'sent by user': sent_by_user, 'trail id': trail_id },
    callback
  );
};

export default logGarminRouteSent;
